import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import MagazineLayout from "@/components/MagazineLayout";

export default function ProfileSent() {
  return (
    <MagazineLayout>
      <div className="min-h-[70vh] bg-cream flex items-center justify-center px-5 py-24">
        <div className="max-w-xl text-center" data-testid="profile-sent-page">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gloss-gold text-ink mb-8">
            <Check size={30} strokeWidth={2.5} />
          </span>
          <p className="overline text-gloss-silver mb-4">With the editorial desk</p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight">Your profile has been sent to the studio.</h1>
          <p className="font-sans text-base text-ink/65 mt-6 leading-relaxed">
            Our editorial team now reviews everything you've shared — your story, photos and details —
            and crafts your feature, cover and interview. We'll polish every word and every image before anything goes live.
          </p>
          <div className="border border-ink/15 bg-white text-left p-6 mt-10 space-y-3">
            <p className="overline text-ink/50">What happens next</p>
            {[
              "The desk reviews your profile and materials",
              "Your feature, cover shoot and interview are crafted",
              "Everything is styled and checked before publication",
              "You'll see it all appear on your member desk",
            ].map((s, i) => (
              <p key={i} className="font-sans text-sm text-ink/75 flex gap-3"><span className="font-mono text-xs text-gloss-gold mt-0.5">{i + 1}</span> {s}</p>
            ))}
          </div>
          <Link to="/portal" className="inline-flex items-center gap-2 mt-10 bg-ink text-cream px-8 py-4 overline hover:bg-gloss-gold hover:text-ink transition-colors" data-testid="back-to-desk">
            Return to your desk <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </MagazineLayout>
  );
}
